const prefix = 'data-table-filter';

export const i18n = {
    selectAll: {
        id: `${prefix}.selectAll`,
        defaultMessage: 'Select all',
    },
} as const;
